import { FC, PropsWithChildren, DetailedHTMLProps, ButtonHTMLAttributes } from 'react';
import classNames from 'classnames';
import styles from './index.module.scss';

interface ButtonProps
  extends DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> {
  className?: string;
  isSuccess?: boolean;
}

export const Button: FC<PropsWithChildren<ButtonProps>> = ({
  children,
  className,
  isSuccess,
  ...rest
}) => (
  <button
    className={classNames(styles.buttonCommon, className, {
      [styles.buttonCommonSuccess]: isSuccess,
    })}
    {...rest}
  >
    {children}
  </button>
);
